/**
 * Auto-validatable Australian Telephone Input that works with Parsley.
 * [data-parsley-au-tel="true"] HTML attribute activates validation.
 */
export default class AustralianTel {
  constructor() {
    if (window.Parsley instanceof Object) {
      const regex = new RegExp('(^1300\\d{6}$)|(^1800|1900|1902\\d{6}$)|(?:\\+?61)?(?:\\(0\\)[23478]|\\(?0?[23478]\\)?)\\d{8}'); // eslint-disable-line
      window.Parsley
        .addValidator('auTel', {
          validateString: val => regex.test(val.replace(/\D/g, '')),
          requirementType: 'string'
        });
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/form/australian-tel.js